import React, { Component } from 'react'

import { connect } from 'react-redux'
import Loading from './Loading'

class LoadingOverlay extends Component {
  render() {
    return (
      <Loading
        open={this.props.loading}
        label={this.props.loadingLabel}
        isGlobalOverlay
      />
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.screen.loading,
  loadingLabel: state.screen.loadingLabel,
})

export default connect(mapStateToProps, null)(LoadingOverlay)
